import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputLogin } from '../components';
import { useEffect, useState } from 'react';
import { useAuthSlice } from '../../../hooks/useAuthSlice';
import { Loader } from '../../../ui/Loader';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline';

export const LoginPage = () => {

  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { token, inicioSesion, loading } = useAuthSlice();
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (token) {
      navigate('/');
    }
    // eslint-disable-next-line
  }, [token])

  const handleClick = () => {
    setHidden(!hidden);
  };



  return (
    <div className="bg-white animate__animated animate__fadeIn">
      {loading && <Loader />}
      <div className="flex justify-center h-screen">
        <div className={`hidden bg-cover lg:block lg:w-2/3 bg-[url('../public/assets/images/central.jpg')]`}>
          <div className="flex items-center h-full px-20 bg-gray-900 bg-opacity-70">
            <div>
              <h2 className="text-4xl font-bold text-white">SICAV</h2>

              <p className="max-w-xl mt-3 text-white">SISTEMA PARA EL CONTROL DE AVALÚOS</p>
            </div>
          </div>
        </div>

        <div className="flex items-center w-full max-w-md px-6 mx-4 lg:mx-auto lg:w-2/6 rounded-none shadow-none my-0">
          <div className="flex-1">
            <div className="text-center">
              <h2 className="text-4xl font-bold text-blue-900 flex justify-center items-center">SICAV</h2>
              <p className="mt-3 text-gray-500">DEPARTAMENTO DE AVALÚOS E INFRAESTRUCTURA</p>
            </div>

            <div className="mt-8">
              <form onSubmit={handleSubmit((data) => inicioSesion(data))}>
                <InputLogin
                  register={register}
                  name='usuario'
                  nameLabel='Usuario'
                  placeholderInput='COJRUIZ'
                  errors={errors}
                />

                <div className='space-y-2 relative '>
                  <InputLogin
                    register={register}
                    name='contrasenia'
                    nameLabel='Contraseña'
                    typeInput={`${hidden ? 'password' : 'text'}`}
                    placeholderInput='********'
                    errors={errors}
                    classInput='pr-11'
                  />
                  {hidden ? <EyeIcon onClick={handleClick} className="absolute right-3 top-5 cursor-pointer h-6 w-6 text-blue-900" /> : <EyeOffIcon onClick={handleClick} className="absolute right-3 top-5 cursor-pointer h-6 w-6 text-blue-900" />}
                </div>
                <div className="mt-6 flex justify-center">
                  <button
                    type="submit"
                    className="font-bold w-36 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-blue-700 rounded-md hover:bg-blue-900 focus:outline-none focus:bg-blue-600 focus:ring focus:ring-blue-300 focus:ring-opacity-50">
                    INGRESAR
                  </button>
                </div>
              </form>
              <p className="mt-6 text-sm text-center text-gray-400">COOPERATIVA DE AHORRO Y CRÉDITO INTEGRAL, COBÁN R. L.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
